// extracted by mini-css-extract-plugin
export default {"header":"styles_header__1vmKN","balance":"styles_balance__zhAWz","pp":"styles_pp__ri41c"};